import Chart from 'chart.js/auto';

var _lastChart = null;

export function render(domId, type, dataJson, optionsJson)
{
    const data = JSON.parse(dataJson);

    var options = {};
    if (optionsJson == "BidderActivity")
        options = _UserActivity_Options(false);
    else if (optionsJson == "SellerActivity")
        options = _UserActivity_Options(true);

    const ctx = document.getElementById(domId);

    if (_lastChart) _lastChart.destroy();

    _lastChart = new Chart(ctx, {
        type: type,
        data: data,
        options: options
    });
}

function _UserActivity_Options(isSeller)
{
    return {
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        var seriesLabel = data['datasets'][tooltipItem.datasetIndex]['label'];

                        if (seriesLabel == 'Buys') {
                            var value = data['datasets'][tooltipItem.datasetIndex]['data'][tooltipItem.index];
                            return "$" + value.toLocaleString() + " total buys";
                        }
                        else if (seriesLabel == 'Sales') {
                            var value2 = data['datasets'][tooltipItem.datasetIndex]['data'][tooltipItem.index];
                            return "$" + value2.toLocaleString() + " total sales";
                        }
                        else if (seriesLabel == 'Bids') {
                            return tooltipItem.yLabel + ' bids';
                        }
                        else if (seriesLabel == 'Page Views') {
                            return tooltipItem.yLabel + ' page views';
                        }
                        else {
                            return tooltipItem.yLabel;
                        }
                    },
                },
            },
            scales: {
                    yLeft: {
                        type: 'linear',
                        position: 'left',
                        title: {
                            display: true,
                            text: 'Bid and Page View Count'
                        }
                    },
                    yRight: {
                        type: 'linear',
                        position: 'right',
                        title: {
                            display: true,
                            text: (isSeller ? "Sales in Dollars" : "Buys in Dollars")
                        },
                        ticks: {
                            callback: function (value) {
                                return "$" + value.toLocaleString(); // Add commas and prepend a dollar sign
                            },
                        },
                    }
            }
        };
}